export default "__VITE_ASSET__CIsBQgvX__"